import { ChatType } from '../types/chat';

export interface ChatPromptCategory {
  category: string;
  prompts: string[];
  chatType: ChatType;
}

export const PREDEFINED_PROMPTS: ChatPromptCategory[] = [
  {
    category: "Profiles Statistics",
    prompts: [
      "How many candidates with knowledge about AWS cloud do we have?",
      "How many people do have Azure certificates? List them by certificate",
      "Show me the total number of candidates in our database",
      "Count the number of candidates for Frontend position, calculate separately for different technologies",
      "Create a bar chart with cloud certificates and how many people we have with such skills",
      "Create a bar chart with programming languages and how many people we have with such skills"
    ],
    chatType: ChatType.General
  },
  {
    category: "Profile information",
    prompts: [
      "Show me 5 developers suitable for a position which requires Java and AWS",
      "Show me candidates for a team lead position for ML project"
    ],
    chatType: ChatType.General
  },
  {
    category: "Skills & Certifications",
    prompts: [
      "Create a table with list of candidates with security certifications",
      "I'm looking for someone that has experience with google analytics or similar tools, format it as a table"
    ],
    chatType: ChatType.General
  },
  {
    category: "Team Composer",
    prompts: [],
    chatType: ChatType.General
  }
];